<template>
  <div>
    <PageHeader />
    <ProjInfo :projectInfo="projectInfo" :changelog="changelog" />


    <v-container class="section-block">

        <v-row>
            <v-col class="col-12 col-md-4" no-gutters>
                <h2>Wavenet voices</h2>
                <p>Holly and all of her english speaking friends are available right inside of After Effects. Voices are organized by gender and region. 
                    This is a lot easier than editing urls, downloading and importing.
                </p>
            </v-col>

            <v-col class="col-12 col-md-4" no-gutters>
                <h2>Auto import</h2>
                <p>
                    In addition to generating Assistaint voices, everything is available to be instantly downloaded and imported directly into your current project and comp.
                </p>
            </v-col>

            <v-col class="col-12 col-md-4" no-gutters>

                <h2>Mic recording</h2>
                <p>It is now possible to record the system mic directly in Ae. 
                    The controls are super simple (record/stop and play) and as with the Wavenet voices, all saved recordings will be automatically imported.
                </p>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-12" no-gutters>
                <v-responsive :aspect-ratio="16/9">
                    <video width="100%" :src="video.tutorial" controls></video>
                </v-responsive>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-12 col-sm-8 col-md-6">
                <h2>Thanks</h2>
                <p>This project came into existence quickly because of a really great idea from <a href="https://moma.corp.google.com/person/aschoneweis@google.com">aschoneweis@</a> and <a href="https://moma.corp.google.com/person/shadarla@google.com">shadarla@</a>.</p>
            </v-col>
        </v-row>


    </v-container>

        <!-- <InstallInfo id="install" :projectInfo="projectInfo" /> -->
    <InstallInfo id="install" name="Conclave" extension :hosts="['After Effects']"/>
    
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'conclave',
  components: {
  },
  data: () => ({
      images: {
            newLayer: require('../assets/images/Dotkit-NewLayer.jpg'),
        },
        video: {
            tutorial: require('../assets/video/Conclave Tut.mp4'),
        },
      projectInfo: {
          name: 'Conclave',
          subtitle: 'Assistant voice for motion',
        //   download: '/download/Conclave_0.4.0.zxp',
        //   version: '0.4',
        //   updated: 'Apr 9, 2020',
          about: `Created to simplify the process of generating Wavenet Assistant TTS audio files for use in production.
                <h3>Supported voices</h3>
                Voices are organized by region (US, UK, and Australian English currently supported) and the typed string may be played and downloaded directly to disk and auto-imported into the current Ae comp at the current playhead time.`
      },
      changelog: [
            {
                version: '0.4.0',
                date: 'Apr 9, 2020',
                comment: [
                    'Initial release',
                ],
            },
        ],
  }),
}
</script>